/** Admin endpoint calls — report moderation queue, account ban, and admin post deletion. */
import type { Account, Report, PaginatedResponse, Language } from '@olimhub/shared'
import type { ReportStatus } from '@olimhub/shared'
import { apiClient } from '../client'

export interface AdminStats {
  totalUsers: number
  newUsersLast7Days: number
  totalPosts: number
  activeToday: number
}

export const adminApi = {
  getStats: () =>
    apiClient.get<AdminStats>('/admin/stats').then((r) => r.data),


  getRecentUsers: () =>
    apiClient.get<Account[]>('/admin/users/recent').then((r) => r.data),

  getReports: (cursor?: string, status?: ReportStatus) =>
    apiClient
      .get<PaginatedResponse<Report>>('/admin/reports', { params: { cursor, status } })
      .then((r) => r.data),

  updateReport: (id: string, status: ReportStatus) =>
    apiClient.put(`/admin/reports/${id}`, { status }).then((r) => r.data),

  banAccount: (id: string, active: boolean) =>
    apiClient.patch(`/accounts/${id}/ban`, { active }).then((r) => r.data),

  deletePost: (id: string) =>
    apiClient.delete(`/posts/${id}`).then((r) => r.data),

  updatePostLanguage: (id: string, language: Language) =>
    apiClient.patch(`/admin/posts/${id}/language`, { language }),

  toggleSuggested: (id: string, isSuggested: boolean) =>
    apiClient.patch(`/admin/accounts/${id}/suggested`, { is_suggested: isSuggested }).then((r) => r.data),
}
